class NSSAccordionGroup extends HTMLElement {
  constructor() {
    super();

    this.debug = false;

    this.els = {
      items: this.querySelectorAll(`.nss-accordion-item`),
    };
  }

  connectedCallback() {
    if (this.debug) console.log(`[NSS][Accordion Group] Connected.`);

    this.addEventListener(`click`, this.handleClick.bind(this));

    // Optional: link the open item's image to an external "detail" image pane
    // (e.g. the "Three lines" section — the left image swaps with the open item).
    if (this.hasAttribute(`nss-link-image`)) this.initImageLink();
  }

  handleClick(e) {
    // Only the header button toggles the item — clicks inside the open
    // answer (e.g. links in the richtext) must not collapse the accordion.
    const button = e.target.closest(`.nss-accordion-item > button`);
    if (!button) return;

    const item = button.closest(`.nss-accordion-item`);
    if (!item || !this.contains(item)) return;

    if (item.classList.contains(`nss-active`)) {
      this.closeAllItems();
    } else {
      this.closeAllItems();
      item.classList.add(`nss-active`);
      this.swapImage(item);
    }
  }

  closeAllItems() {
    this.els.items.forEach((itemEl) => {
      itemEl.classList.remove(`nss-active`);
    });
  }

  initImageLink() {
    const section = this.closest(`nss-hero`) || this.closest(`[data-section-id]`);
    this.targets = section ? Array.from(section.querySelectorAll(`[nss-detail-target]`)) : [];
    if (!this.targets.length) return;

    this.els.items.forEach((itemEl) => {
      const url = itemEl.getAttribute(`nss-accordion-image`);
      if (url) new Image().src = url;
    });

    const openItem = Array.prototype.find.call(this.els.items, (i) =>
      i.classList.contains(`nss-active`)
    );
    if (openItem) this.swapImage(openItem);
  }

  swapImage(item) {
    if (!this.targets || !this.targets.length) return;

    const url = item.getAttribute(`nss-accordion-image`);

    this.targets.forEach((target) => {
      const pane = target.parentElement || target;
      const video = pane.querySelector(`video`);
      let img = target.querySelector(`img`);

      if (!url) {
        if (img) {
          if (img.hasAttribute(`nss-detail-swap`)) {
            img.style.display = `none`;
          } else if (img.getAttribute(`nss-base-src`)) {
            this.fadeTo(img, img.getAttribute(`nss-base-src`));
          }
        }
        if (video) video.style.display = ``;
        return;
      }

      if (!img) {
        img = document.createElement(`img`);
        img.setAttribute(`nss-detail-swap`, ``);
        img.alt = ``;
        img.style.width = `100%`;
        img.style.height = `100%`;
        img.style.objectFit = `cover`;
        pane.style.position = `relative`;
        target.style.position = `absolute`;
        target.style.inset = `0`;
        target.appendChild(img);
      } else if (!img.hasAttribute(`nss-detail-swap`) && !img.getAttribute(`nss-base-src`)) {
        img.setAttribute(`nss-base-src`, img.getAttribute(`src`));
      }

      if (video) video.style.display = `none`;
      img.style.display = ``;
      this.fadeTo(img, url);
    });
  }

  fadeTo(img, url) {
    if (img.getAttribute(`src`) === url) return;

    img.style.transition = `opacity 0.2s ease-in-out`;
    img.style.opacity = `0`;

    window.setTimeout(() => {
      const pre = new Image();
      pre.onload = () => {
        img.removeAttribute(`srcset`);
        img.removeAttribute(`sizes`);
        img.src = url;
        img.style.opacity = `1`;
      };
      pre.onerror = () => {
        img.style.opacity = `1`;
      };
      pre.src = url;
    }, 180);
  }
}

let elementName = `nss-accordion-group`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSAccordionGroup);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
